module.exports = __webpack_public_path__ + "images/locator/icon-ribbon-e6c8dc46.svg";